import './polyfill';
import './localisation';

import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import $ from 'jquery';

import VueLazyLoad from 'vue-lazyload';
import BootstrapVue from 'bootstrap-vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueSelect from 'vue-select';
import VueRouter from 'vue-router';
import * as Logger from 'js-logger';

import Config from './config.json';

import * as Store from './store';
import { store } from './store';

import router from './router';

import AdminLayout from './components/layout';

// Styles and fonts
import '../node_modules/font-awesome/css/font-awesome.min.css';
import 'vue-select/dist/vue-select.css';

import template from './main.vue';

import WebsocketClient, { WebsocketsListener } from './utils/ws';

let logLevel = (Config.debug ? Logger.DEBUG : Logger.ERROR);
Logger.useDefaults();
Logger.setLevel(logLevel);

Vue.use(VueLazyLoad);
Vue.use(BootstrapVue);

Vue.component('v-select', VueSelect)
Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;

Vue.config.errorHandler = function(err, vm, info) {
    Logger.error('Vue error: ', err);
};

// Init websocket client
new WebsocketClient();

// Get user data from localstorage
let userData: any;
const userDataString = localStorage.getItem('hud');
if (userDataString) {
    try {
        userData = JSON.parse(userDataString);
    } catch (e) {

    }
}

@Component({
    mixins: [template],
    store,
    components: {
        AdminLayout
    },
    router
})

class App extends Vue {

    isAdmin: boolean = false;
    wsListener: WebsocketsListener;

    constructor() {
        super();
        this.wsListener = new WebsocketsListener();
    }

    mounted() {

        // Assign session values to store for global dispatch
        this.wsListener.onGet('wss.session', (success: boolean, data: any) => {
            if (success) {

                this.wsListener.setAuthState(success, data);

                Store.commitLoggedInUser(this.$store, data);
                Store.commitLoggedInState(this.$store, true);

                this.isAdmin = data.isAdmin;

            }

            Store.commitCheckingSession(this.$store, false);
        });

    }

    isCheckingSession() {
        return Store.readCheckingSession(this.$store);
    }

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }

    hasLoaderActive() {
        return Store.readLoaderVisibility(this.$store);
    }
}

window.onerror = function (errorMsg, url, lineNo, colNo, error) {
    Logger.error('Global event: ', errorMsg);
    Store.commitLoaderVisibility(store, false);
};

export const app = new App().$mount('#app');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts